import React, { useCallback, useState } from "react"
import styled from "styled-components"
import Button from "../../components/Button"
import { useConfigDataState } from "../../globalStates/ConfigDataState"
import { useExhibitorDataState } from "../../globalStates/ExhibitorDataState"
import { useLanguageState } from "../../globalStates/LanguageState"
import { useLoadingState } from "../../globalStates/LoadingState"
import { useNotificationsDataState } from "../../globalStates/NotificationDataState"
import { useReferenceDataState } from "../../globalStates/ReferenceDataState"
import FailedValidationModal from "./FailedValidationsModal"
import { useHookstate } from "@hookstate/core"
import ModalOk from "../../components/Modal/ModalOk"

const ActionsWrapper = styled.div`
    display: flex;
    & button {
        width: 150px;
        margin: 0 5px;
        font-size: 12px;
        line-height: 14px;
        text-align: center;
    }
`

const Actions: React.FC<{}> = (props) => {
    const branding = useLanguageState().getStrings()

    const [discardModalVisible, setDiscardModalVisible] = useState<boolean>(false)
    const [validationModalVisible, setValidationModalVisible] = useState<boolean>(false)

    const loadingState = useLoadingState()
    const refDataState = useReferenceDataState()
    const exiState = useExhibitorDataState()
    const notifState = useNotificationsDataState()
    const serviceKeys = useConfigDataState().getServiceKeys()

    const organizationState = exiState.getOrganization()
    const organization = useHookstate(organizationState)

    const organizationBackupState = exiState.getOrganizationBackup()
    const organizationBackup = useHookstate(organizationBackupState)

    const discardClickHandler = useCallback(() => {
        setDiscardModalVisible(true)

        // eslint-disable-next-line
    }, [])

    const publishClickHandler = useCallback(() => {
        const isInvalid = exiState.getOrganization().invalid()

        if (isInvalid) {
            setValidationModalVisible(true)
        } else {
            loadingState.setActive(true, "Please wait while publising takes place ...")
            exiState
                .save(serviceKeys, refDataState)
                .then(() => notifState.addSuccess(branding.configuration.validationMessages.successMessageText))
                .then(() => {
                    exiState.reinit(serviceKeys).then(() => {
                        loadingState.setActive(false, "")
                    })
                })
                .catch((error) => {
                    loadingState.setActive(false, "")
                    console.log(error)
                    notifState.addError(error)
                })
        }
        // eslint-disable-next-line
    }, [exiState, loadingState, notifState, refDataState, serviceKeys])

    return (
        <ActionsWrapper>
            {discardModalVisible && (
                <ModalOk
                    name="discard"
                    title={branding.configuration.actionbar.modalDiscardTitle}
                    visible={discardModalVisible}
                    onOk={() => {
                        organization.set(JSON.parse(JSON.stringify(organizationBackup.get())))
                        setDiscardModalVisible(false)
                    }}
                    onClose={() => {
                        setDiscardModalVisible(false)
                    }}
                    labelOk={branding.configuration.actionbar.modalDiscardOK}
                    labelClose={branding.configuration.actionbar.modalDiscardCancel}
                >
                    {branding.configuration.actionbar.modalDiscardText}
                </ModalOk>
            )}
            {validationModalVisible && (
                <FailedValidationModal
                    visible={validationModalVisible}
                    onClose={() => {
                        setDiscardModalVisible(false)
                    }}
                />
            )}
            <Button
                id="discard"
                caption={branding.configuration.actionbar.btnDiscard}
                inverse={false}
                onClick={discardClickHandler}
            />
            <Button
                id="publish"
                caption={branding.configuration.actionbar.btnPublish}
                inverse={true}
                onClick={publishClickHandler}
            />
        </ActionsWrapper>
    )
}

export default Actions
